import appConfig from "@/config";

export type InviteKind = "parent-student" | "gift";

export function getInviteUrl(
  inviteToken: string,
  kind: InviteKind = "parent-student"
): string {
  const rootUrl =
    appConfig.environment === "production"
      ? "https://wiswiz.nl"
      : appConfig.environment === "staging"
        ? "https://staging.wiswiz.nl"
        : appConfig.redirectUri.replace(/\/aanmelden\/callback$/, "");

  const path = kind === "gift" ? "invite/gift" : "invite";
  return `${rootUrl}/${path}/${inviteToken}`;
}

export function getStudentToParentIntro(hasUsedTrial: boolean): string {
  return hasUsedTrial
    ? "WisWiz helpt leerlingen wiskunde te begrijpen met ondersteuning direct bij de lesboeken. Via deze link kan je voor mij een WisWiz abonnement afsluiten (€6,99 p/m)."
    : "WisWiz helpt leerlingen wiskunde te begrijpen met ondersteuning direct bij de lesboeken. Via deze link kan je een proefweek voor me starten, 7 dagen gratis, daarna €6,99/maand.";
}

export function getStudentToParentMessage(
  inviteUrl: string,
  hasUsedTrial: boolean
): string {
  return `${getStudentToParentIntro(hasUsedTrial)}\n\n${inviteUrl}`;
}

export function getParentToStudentIntro(): string {
  return "Ik heb WisWiz voor je geactiveerd. Via deze link kun je je aanmelden en krijg je direct toegang.";
}

export function getParentToStudentMessage(inviteUrl: string): string {
  return `${getParentToStudentIntro()}\n\n${inviteUrl}`;
}

export function getInviteIntro(
  context: "student-to-parent" | "parent-to-student",
  hasUsedTrial: boolean
): string {
  return context === "student-to-parent"
    ? getStudentToParentIntro(hasUsedTrial)
    : getParentToStudentIntro();
}

export function getWhatsappMessage(
  context: "student-to-parent" | "parent-to-student",
  inviteUrl: string,
  hasUsedTrial: boolean
): string {
  return context === "student-to-parent"
    ? getStudentToParentMessage(inviteUrl, hasUsedTrial)
    : getParentToStudentMessage(inviteUrl);
}

export async function copyToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }
}
